__turbopack_context__.v({
  "photo_gallery__photo": "No9hzq_photo_gallery__photo",
  "photo_gallery__photo_wrapper": "No9hzq_photo_gallery__photo_wrapper",
});
